var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { ColorCodedState } from '../../@types/ui.controller.types';
import { getAppLink, getWordPressLink } from '../../env';
import { useControllers } from '../../hooks/controller.hooks';
import { makeForm } from '../../mediators/form.mediator';
import { makeContactForm } from '../../models/makeContactForm.model';
import { submitContactForm } from '../../requests/submitContactForm.request';
import { reportError } from '../../utils/errors.utils';
import { asyncGetRecaptchaToken, checkErrorForRecaptchaFailure } from '../../utils/loadRecaptcha.utils';
import { useStore } from '../../utils/mobx.utils';
import { copyWithJSON } from '../../utils/objects.utils';
import { toLowerCase } from '../../utils/string.utils';
import { getNowTimestampUtc } from '../../utils/time.utils';
import { validateEmail } from '../../validators/email.validator';
import { validatePhone } from '../../validators/phone.validator';
import BaseButton from '../BaseButton/BaseButton';
import ContactFormEditor from '../ContactFormEditor/ContactFormEditor';
import InfoBanner from '../InfoBanner/InfoBanner';
import ShadedBlock from '../ShadedBlock/ShadedBlock';
var ContactForm = function (props) {
    var _a = useControllers(), API = _a.API, UI = _a.UI;
    var s = useStore(function () { return ({
        email: "",
        phone: "",
        form: makeForm(makeContactForm()),
        get hasValidEmail() {
            return s.form.value.email && validateEmail(s.form.value.email) === true;
        },
        get hasValidPhone() {
            return (s.form.value.phone === "" || s.form.value.phone) && validatePhone(s.form.value.phone, true) === true;
        },
        get formIsValid() {
            return s.hasValidEmail && s.form.value.name && s.hasValidPhone && s.form.value.type && s.form.value.body;
        },
    }); });
    var save = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, contactFormSnapshot, savedContactForm, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, asyncGetRecaptchaToken('turn2me_contact_form', UI, API)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    checkErrorForRecaptchaFailure(e_1);
                    UI.DIALOG.error({
                        heading: 'You have not passed the Recaptcha test. Please try again.',
                        error: e_1,
                    });
                    return [2 /*return*/];
                case 3:
                    contactFormSnapshot = copyWithJSON(s.form.value);
                    contactFormSnapshot.type = toLowerCase(contactFormSnapshot.type);
                    contactFormSnapshot.timeCreated = getNowTimestampUtc();
                    contactFormSnapshot.timeUpdated = getNowTimestampUtc();
                    contactFormSnapshot.userId = null;
                    _a.label = 4;
                case 4:
                    _a.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, submitContactForm(API, contactFormSnapshot)];
                case 5:
                    savedContactForm = _a.sent();
                    if (!savedContactForm) {
                        UI.DIALOG.attention({
                            heading: "Something wasn't quite right...",
                            body: 'Your contact form might have not been submitted correctly; please refresh the page and try again.',
                        });
                        return [2 /*return*/];
                    }
                    s.form.reset(__assign({}, makeContactForm()));
                    UI.DIALOG.success({ heading: 'Your contact form has been submitted!' });
                    return [3 /*break*/, 7];
                case 6:
                    e_2 = _a.sent();
                    reportError(e_2);
                    UI.DIALOG.error({
                        heading: "Failed to submit contact form...",
                        error: e_2,
                    });
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return React.createElement(Observer, { children: function () { return (React.createElement("article", { className: "page__article single__article" },
            React.createElement("div", { className: "single__article-content page__article-content" },
                React.createElement(InfoBanner, { icon: "info" },
                    React.createElement("p", null,
                        "Important information: ",
                        React.createElement("strong", null,
                            "Support group counselling services are ",
                            React.createElement("u", null, "NOT"),
                            " provided through this form.")),
                    React.createElement("p", null,
                        "If you are looking for support of this type, please either sign up for a ",
                        React.createElement("a", { href: getAppLink('/app/support-groups'), title: "Support Group", target: "_blank", rel: "noreferrer" }, "support group"),
                        " or a ",
                        React.createElement("a", { href: getAppLink('/app/counselling'), title: "Counselling Application", target: "_blank", rel: "noreferrer" }, "counselling application"),
                        ", or go to the ",
                        React.createElement("a", { href: getWordPressLink('/crisis-support'), title: "Crisis Support", target: "_blank", rel: "noreferrer" }, "Crisis Support"),
                        " page if you need immediate help."),
                    React.createElement("p", null, "This contact form is meant for general enquiries related to topics such as services, donations, website functionalities, or business enquiries.")),
                React.createElement(ShadedBlock, { spaceChildren: true, color: "green" },
                    React.createElement(ContactFormEditor, { form: s.form, requireEmail: true, requireName: true, showMoreOptionsSection: true }),
                    !s.formIsValid && React.createElement(InfoBanner, { colorCodedState: ColorCodedState.attention }, "Your contact form needs a valid email address, name, topic and message."),
                    React.createElement(BaseButton, { dataCy: "profile-editor-save-profile-button", size: "md", onClick: save, icon: "arrow", iconVariant: "filled", disabled: !s.formIsValid }, "Submit"))))); } });
};
export default ContactForm;
